var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"flex flex-row button-container-base button-container",class:[
    (_vm.type + "-background" + (_vm.dark ? '-dark' : '')),
    _vm.fixedSize ? _vm.fixedSize : '' ],on:{"click":_vm.onClickHandler}},[_c('div',{staticClass:"button-img-wrapper"},[_c('img',{attrs:{"src":require('@/assets/' + _vm.image)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }